import Vue from 'vue';

import PlayerDetailsForm from '@/components/Modals/PlayerDetailsForm.vue';
import { MyDetails } from '@/models/MyPlayerDetails';

export class RoomModalService {
  constructor(private vue: Vue) {}

  showPlayerDetailsForm = (details: MyDetails | null, clickToClose = true) =>
    new Promise<MyDetails>(resolve => {
      // eslint-disable-next-line
      (this.vue as any).$modal.show(
        PlayerDetailsForm,
        {
          playerDetails: details,
          callback: resolve
        },
        {
          clickToClose, // prevents the modal closes when clicking on the background or escaping
          adaptive: true,
          height: 'auto'
        }
      );
    });
}
